import abbreviateNum from '/src/scripts/rebuild/abbreviate-num.js';

export default async function(options) {
    const sliderFiat = document.querySelector('[data-noui="fiat"] [data-nouitarget]')
    const inputFiat = document.getElementById('input-number2')
    const sliderCrypto = document.querySelector('[data-noui="crypto"] [data-nouitarget]')
    const coin = document.querySelector('.slider-calc').getAttribute('data-short');
    const inputCrypto = document.getElementById('input-number')
    const { slider, input, coinData } = options
    const { price } = coinData

    async function calc(target) {
        let type = target.closest('[data-noui]').getAttribute('data-noui')
        let targetSlider
        let targetInput
        let sum
        let yearlyPercent;

        if(coin.toLowerCase() === 'awc') {
            let val = +inputCrypto.value
            console.log(val)
            switch(true) {
                case (val < 10):
                    yearlyPercent = 0;
                    break;

                case (val >= 10 && val <= 999):
                    yearlyPercent = 20;
                    break;
              
                case (val >= 999 && val < 10000):  
                    yearlyPercent = 20;
                    break;
              
                default:
                    yearlyPercent = 20;
                    break;
              }
        } else {
            yearlyPercent = +(document.querySelector('[data-reward]').getAttribute('data-reward')) || 0
            console.log(yearlyPercent)
        }

        let monthlyPercent = yearlyPercent / 12;
        let dailyPercent = yearlyPercent / 365;
        let yearlyProfit;
        let monthlyProfit;
        let dailyProfit;

        if (type === 'fiat') {
            targetSlider = sliderCrypto
            targetInput = inputCrypto

            sum = input.value / price

            yearlyProfit = abbreviateNum(sum * yearlyPercent / 100);
            monthlyProfit = abbreviateNum(sum * monthlyPercent / 100);
            dailyProfit = abbreviateNum(sum * dailyPercent / 100);

        } else {
            targetSlider = sliderFiat
            targetInput = inputFiat

            sum = input.value * price

            yearlyProfit = abbreviateNum(input.value * yearlyPercent / 100);
            monthlyProfit = abbreviateNum(input.value * monthlyPercent / 100);
            dailyProfit = abbreviateNum(input.value * dailyPercent / 100);
        }


        targetSlider.noUiSlider.set(sum)
        targetInput.value = sum.toFixed(4)

        document.querySelector('[data-daily-crypto]').innerHTML = dailyProfit;
        document.querySelector('[data-monthly-crypto]').innerHTML = monthlyProfit;
        document.querySelector('[data-yearly-crypto]').innerHTML = yearlyProfit;
        document.querySelector('.slider-calc [data-reward]').innerHTML = '+' + yearlyPercent + '%';
        document.querySelector('.first-staking-section__name [data-reward]').innerHTML = yearlyPercent + '%';
    }

    input.addEventListener('input', async function(){
        slider.noUiSlider.set(this.value)
        await calc(this)
    })
    slider.noUiSlider.on('slide', async function (values, handle) {
        input.value = values[handle]
        await calc(this.target)
    })
}